import { useCallback } from 'react';

import { Spinner } from 'core/components/Spinner';
import { STATUS } from 'core/store';
import { useShallowEqualSelector } from 'core/modules/hooks';
import type { StoreState } from '../../types';

import { SpinnerMessage, SpinnerWrapper } from './SystemSpinner.styles';

export default function SystemAlerts(): JSX.Element {
  const { message, status } = useShallowEqualSelector((s: StoreState) => s.app.loading);

  const renderSpinner = useCallback(() => {
    if (status !== STATUS.SUCCESS) {
      return null;
    }

    return (
      <SpinnerWrapper>
        <Spinner />
        <SpinnerMessage>{message}</SpinnerMessage>
      </SpinnerWrapper>
    );
  }, [status, message]);

  return <>{renderSpinner()}</>;
}
